import React from 'react';

import Urls from '../../../config/index';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Pagination, Row, Col,Upload,Icon } from 'antd';
import Serach from '../../utils/serach';
import Add from '../../utils/add';
import Edit from '../../utils/edit';
import Head from '../../utils/head';
import request from '../../utils/request';
import { paramsEncode } from '../../utils/index';
import { connect } from 'react-redux';

const FormItem = Form.Item;

let getTecentConfigList = Urls.TecentConfigUrl.list;
let modify = Urls.TecentConfigUrl.modify;
let find = Urls.TecentConfigUrl.selectById;

//export default class extends React.Component {
class TecentConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            list: [],
            serach: {
                page: 1,
                pageSize: 10,
            },
        };
        this.onChange = this.onChange.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
      
    }
    componentWillMount() {
        this.getList(getTecentConfigList + paramsEncode(this.state.serach));
    }

    getList(url) {
        (async url => {
            try {
                let response = await request(url);
                console.log("结果集",response);
                this.setState(Object.assign(this.state.list, response));
            } catch (e) {
                message.error(e.message);
            }
        })(url);
    }


    onChange(current, pageSize) {
        let _serach = Object.assign(this.state.serach, { page: current, pageSize: pageSize });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(getTecentConfigList + paramsEncode(this.state.serach));
    }

    serach(serach) {
        //记录搜索文本
        let _serach = Object.assign(this.state.serach, serach, { page: 1 }); //page = 1
        this.setState(Object.assign(this.state, { serach: _serach }));
        (async url => {
            try {
                let response = await request(url);
                this.state.list = response;
                this.setState(Object.assign(this.state, response));
            } catch (e) {
                console.log(e);
                message.error('查询失败');
            }
        })(getTecentConfigList + paramsEncode(this.state.serach));
    }

    handleRefresh() {
        let _serach = Object.assign(this.state.serach, { page: 1 });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(getTecentConfigList + paramsEncode(this.state.serach));
        this.state.resourceIds = [];
    }

    render() {
        let metadata = [];
        let addMetas = [
            // {
            //     type: 'Input',
            //     placeholder: 'type',
            //     label: 'type',
            //     isRequired: true,
            //     field: 'type',
            // },
            {
                type: 'Input',
                placeholder: 'desc',
                label: 'desc',
                isRequired: true,
                field: 'desc',
            },
            {
                type: 'Input',
                placeholder: 'value',
                label: 'value',
                isRequired: true,
                field: 'value',
            },
            {
                type: 'Input',
                placeholder: 'remark',
                label: 'remark',
                isRequired: false,
                field: 'remark',
            }
        ];
        const columns = [
            {
                title: 'type',
                dataIndex: 'type',
                key: 'type',
            },
            {
                title: 'desc',
                dataIndex: 'desc',
                key: 'desc',
            },
            {
                title: 'value',
                dataIndex: 'value',
                key: 'value',
            },
            {
                title: 'remark',
                dataIndex: 'remark',
                key: 'remark',
            },
            {
                title: '操作',
                key: 'action',
                render: record => (
                    <span>
                        <Edit
                            metadata={addMetas}
                            url={modify}
                            find={find + '' + record._id}
                            handleRefresh={this.handleRefresh}
                        />
                    </span>
                ),
            },
        ];
        return (
            <div>
                <Row className="searchRow">
                    <Col span={4}>
                        <h2>work主机配置列表</h2>
                    </Col>
                    <Col span={20} style={{ textAlign: 'right' }}>
                      <Head
                        serachMeta={metadata}
                        addUrl={modify}
                        handleRefresh={this.handleRefresh}
                        handleSerach={this.serach.bind(this)}
                      /> 
                    </Col>
                </Row>
              
                <Table columns={columns} dataSource={this.state.list} pagination={false} bordered  
                rowKey="_id"/>
                <Pagination
                    showQuickJumper
                    showSizeChanger
                    current={this.state.serach.page}
                    total={this.state.total}
                    className="ant-table-pagination"
                    onChange={this.onChange}
                    onShowSizeChange={this.onChange}
                />
            </div>
        );
    }
}
export default connect()(Form.create()(TecentConfig));



// WEBPACK FOOTER //
// ./components/sider/tecentConfig.js